require("!!/application/home/gitlab-runner/builds/yZwn96JDx/0/vernuso/trust/node_modules/script-loader/addScript.js")(require("!!/application/home/gitlab-runner/builds/yZwn96JDx/0/vernuso/trust/node_modules/raw-loader/index.js!/application/home/gitlab-runner/builds/yZwn96JDx/0/vernuso/trust/node_modules/hammerjs/hammer.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/hammerjs/hammer.min.js
// module id = 1106
// module chunks = 2